import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b6b6eea0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "dot"
}

import { computed, ref, onMounted, onUnmounted } from 'vue';
import RadioButton from './RadioButton.vue';

/**
 * T is an enum type
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'RadioButtonToggle',
  props: {
    name: {},
    modelValue: {},
    options: {}
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "70e7bb5c": (dotX.value),
  "70e7bb5d": (dotY.value),
  "5e9b7abc": (anchor.value)
}))

const props = __props;
const emits = __emit
const choice = computed({
    get() {
        return props.modelValue.toString();
    },
    set(val) {
        emits('update:modelValue', val);
    }
})
const keys = computed(()=>Object.keys(props.options));
const main = ref<HTMLElement>();
const dotDisplayed = ref<HTMLElement>();
const anchor = ref(`--${keys.value[0]}`);
const dotX = ref('');
const dotY = ref('');
function updateAnchor(id: string) {
    anchor.value = `--${id}`;
}
function updateDotPos(el?: HTMLElement) {
    dotDisplayed.value = el;
    const b = dotDisplayed.value?.getBoundingClientRect();
    const a = main.value?.getBoundingClientRect();
    if (a && b) {
        dotX.value = `${b.left-a.left}px`;
        dotY.value = `${b.top-a.top}px`;
    }
}
function updateCurDotPos() {
    updateDotPos(dotDisplayed.value);
}
onMounted(()=>window.addEventListener('resize',updateCurDotPos));
onUnmounted(()=>window.removeEventListener('resize',updateCurDotPos));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", {
    ref_key: "main",
    ref: main,
    class: "radio-group"
  }, [
    (dotDisplayed.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(keys.value, (k) => {
      return (_openBlock(), _createElementBlock("li", {
        class: "entry",
        key: k
      }, [
        _createVNode(RadioButton, {
          id: `${_ctx.name}-${k}`,
          modelValue: choice.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((choice).value = $event)),
          name: _ctx.name,
          value: k,
          label: _ctx.options[k],
          hideCheck: "",
          onChange: _cache[1] || (_cache[1] = (el,val)=>{updateDotPos(el);updateAnchor(val);emits('change');})
        }, null, 8, ["id", "modelValue", "name", "value", "label"])
      ]))
    }), 128))
  ], 512))
}
}

})